import { FoodsIllustrations, WhiteBox } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const NoGoalDefined = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <WhiteBox>
            <Stack gap={theme.spacing(4)} padding={theme.spacing(8, 4)} justifyContent={"center"} alignItems={"center"}>
                <FoodsIllustrations illustration={"notEnoughData"} />
                <Typography variant="body-bold">{t("actionplan.trajectory.notenoughgoals")}</Typography>
            </Stack>
        </WhiteBox>
    );
};
